import { FieldNumberOutlined, FieldTimeOutlined, FileTextOutlined, HomeOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Form, Input, Layout, Space, Switch } from "antd";
import { Content, Header } from 'antd/es/layout/layout';
import { useEffect, useState } from "react";
import { NamespacedCCParts, ScheduledTaskDef } from "../../apis/mgmt/api";
import { NamespacedCCPartsListForm } from "../cconfig/NamespacedCCPartsListForm";
import { DataForm } from "../common/DataForm";
import { DataViewProps } from "../common/DataView";
import { useStatefulList } from "../common/List";
import { AgentTaskDefSelect, TaskDefFormItem } from '../task/TaskDefSelect';
import { cronRegex } from './CronRegExp';
import { AgentDomainSelect, DomainFormItem, DomainSelect } from '../domain/DomainSelect';

export const ScheduledTaskDefForm = function (
    props: DataViewProps<ScheduledTaskDef>
) {

    const data = props.data;
    const id = data?.id;
    
    const [ selectedTab,setSelectedTab ] = useState("scope");
    useEffect(() => { setSelectedTab('scope'); }, [id]);
    const selectedTabStyle = (tab: string) => selectedTab===tab? {} : {'display': 'none'};

    const namespacedCCPartsList = useStatefulList<NamespacedCCParts>(props.data?.namespacedCCParts, (data) => {
        if (!data.namespace) throw new Error('Namespace is required');
        return data.namespace       
    });
    useEffect(() => { namespacedCCPartsList.setData(data?.namespacedCCParts); }, [data]);

    return (
        <Layout className="h-100" >
        <Header style={{'paddingBottom': '1em'}}>
        <Space.Compact direction="horizontal" >
            <Button type="text" onClick={()=>setSelectedTab('scope')}><HomeOutlined />Principal</Button>
            <Button type="text" onClick={()=>setSelectedTab('config')} disabled={!id}><SettingOutlined />Configuración</Button> 
        </Space.Compact>
        </Header>
        <Content className="h-100">
            <div style={selectedTabStyle('scope')} className="h-100">
                <DataForm {...props} >
                    
                    {/* id */}
                    <Form.Item
                        className="input"
                        name="id"
                    >
                        <Input prefix={<FieldNumberOutlined className="site-form-item-icon" />} placeholder="ID" disabled={true} />
                    </Form.Item>

                    <Form.Item
                        name="enabled"
                        valuePropName="checked"
                    >
                        <Switch
                            checkedChildren="Enabled"
                            unCheckedChildren="Disabled"
                            defaultChecked={data?.enabled || false}
                            style={{ marginTop: '2em' }}
                        />
                    </Form.Item>

                    {/* taskDef */}
                    <TaskDefFormItem
                        name="taskDef"
                        rules={[{ required: true, message: '¡Please select the task definition!' }]}
                    >
                        <AgentTaskDefSelect
                            agentDefId={data?.taskDef?.agentId}
                        />
                    </TaskDefFormItem>

                    {/* title */}
                    <Form.Item
                        className="input"
                        name="title"
                        rules={[{ required: true, message: '¡Please input the title!' }]}
                    >
                        <Input prefix={<FileTextOutlined className="site-form-item-icon" />} placeholder="Title" />
                    </Form.Item>

                    {/* cronExpression */}
                    <Form.Item
                        className="input"
                        name="cronExpression"
                        rules={[
                            {
                                required: true,
                                message: 'Please set a cron expression',
                            },
                            {
                                pattern: cronRegex,
                                message:
                                'Invalid format: must follow the format "<seconds> <minutes> <hours> <day of month> <month> <day of week>"',
                            },
                          ]}
                    >
                        <Input prefix={<FieldTimeOutlined className="site-form-item-icon" />} placeholder="Cron expression. Ej: 0 0 12 * * ?" />
                    </Form.Item>
                    <pre style={{'fontSize': '0.8em', 'color': '#999999', display: 'block', 'margin': '0.5em 0 0 0'}}> 
                    <div> </div>
                    <div>┌───────────── second (0-59)</div>
                    <div>│ ┌───────────── minute (0 - 59)</div>
                    <div>│ │ ┌───────────── hour (0 - 23)</div>
                    <div>│ │ │ ┌───────────── day of the month (1 - 31)</div>
                    <div>│ │ │ │ ┌───────────── month (1 - 12) (or JAN-DEC)</div>
                    <div>│ │ │ │ │ ┌───────────── day of the week (0 - 7)</div>
                    <div>│ │ │ │ │ │          (0 or 7 is Sunday, or MON-SUN)</div>
                    <div>│ │ │ │ │ │</div>
                    <div>* * * * * *</div>
                    <div> </div>
                    <div>0 0 * * * * = the top of every hour of every day</div>
                    <div>*/10 * * * * * = every ten seconds</div>
                    <div>0 0 8-10 * * * = 8, 9 and 10 o'clock of every day</div>
                    <div>0 0 6,19 * * * = 6:00 AM and 7:00 PM every day</div>
                    <div> </div>
                    </pre>
                    <i><a target="_blank" href="https://docs.spring.io/spring-framework/docs/current/javadoc-api/org/springframework/scheduling/support/CronExpression.html#method-detail">See more samples and documentation</a></i>
                    
                </DataForm>
            </div><div style={selectedTabStyle('config')} className="h-100">
                <NamespacedCCPartsListForm {...namespacedCCPartsList} />
            </div>
        </Content>
        </Layout>
    );

};
